// extracted by mini-css-extract-plugin
export var fullGrid = "_30-3";
export var pdpPreviewContainer = "_30-1";
export var previewContainer = "_30-0";
export var togglePreviewContainer = "_30-2";